import {makeStyles, Theme} from "@material-ui/core";
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0px 4px 20px rgba(19, 123, 189, 0.08)",
    borderBottom: "1px solid rgba(229, 231, 235, 0.8)",
    position: "sticky",
    top: 0,
    zIndex: 999,
  },
  container: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: 1440,
    margin: "0 auto",
    width: "100%",
    padding: "0 24px",
    [theme.breakpoints?.down("sm")]: {
      padding: "0 8px",
    },
  },
  logo: {
    height: "auto",
    objectFit: "cover",
    cursor: "pointer",
    padding: 5,
    maxHeight: 60,
    maxWidth: 60,
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  list: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: 0,
  },
  listItems: {
    fontSize: 14,
    margin: "0 8px",
    padding: "20px 0px",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    [theme.breakpoints?.up("lg")]: {
      margin: "0 20px",
      fontSize: 15,
    },
    "&:hover": {
      "& $listItems__lesson , $listItems__profile , $listItems__test": {
        display: "block",
      },
    },
  },

  listItems__text: {
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    borderRadius: 8,
    padding: "6px 12px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      color: "#137BBD",
      backgroundColor: "rgba(19, 123, 189, 0.06)",
    },
  },

  listItems__lesson: {
    display: "none",
  },
  listItems__profile: {
    display: "none",
  },
  listItems__test: {
    display: "none",
  },

  listItems__content: {
    padding: "10px 0 10px 10px",
    position: "absolute",
    backgroundColor: " #f9f9f9",
    top: 80,
    minWidth: 200,
    boxShadow: "0px 3px 16px 0px rgba(0,0,0,0.2)",
    zIndex: 1,
    borderRadius: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  listItems__content__title: {
    color: "#767676",
    cursor: "pointer",
    marginTop: 10,
    marginBottom: 15,
    paddingLeft: 10,
    "&:hover": {
      color: "#157BBC",
    },
  },
  avatar: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    marginLeft: 10,
  },
  menu: {
    "& .MuiPaper-root": {
      borderRadius: "12px",
      backgroundColor: "#fff",
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.15)",
      overflowX: "hidden",
      overflowY: "auto",
      padding: "8px 0",
      minWidth: 220,
      width: "auto",
    },
    "& .MuiList-root": {
      width: "100%",
      padding: 0,
    },
    "& .MuiMenuItem-root": {
      padding: "10px 20px",
      fontSize: 14,
      fontWeight: 500,
      whiteSpace: "nowrap",
      "&:hover": {
        backgroundColor: "rgba(19, 123, 189, 0.08)",
        color: "#137BBD",
      },
    },
  },

  btn_profile: {
    padding: "5px 15px 5px 15px",
    border: "1px solid #DDDDDD",
    backgroundColor: "#ffffff",
    borderRadius: 25,
    height: 42,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      "&:hover": {
        boxShadow: "0px 2px 4px rgb(0 0 0 / 18%)",
        transition: "box-shadow 0.25s ease",
      },
    },
  },
  exit: {
    display: "flex",
    alignItems: "center",
    "& > h6": {
      cursor: "pointer",
      "&:hover": {
        color: "red",
      },
    },
  },
  icon_exit: {
    color: "red",
    cursor: "pointer",
    marginRight: 5,
  },
  drawer_container: {
    zIndex: 1300,
    width: "100%",
    "& .MuiDrawer-paper": {
      padding: "15px 0 0 15px",
      width: 250,
      backgroundColor: "#fff",
      color: "#000",
      [theme.breakpoints?.down("sm")]: {
        width: 200,
      },
    },
  },
  avatar_mobile: {
    display: "inline-block",
    cursor: "pointer",
    fontSize: 30,
    marginRight: 10,
    color: "#e9dada",
    marginTop: 5,
  },
  username: {
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  list__item: {
    padding: "10px 5px",
    "& > a": {
      color: "#000",
      fontSize: 13,
      position: "relative",
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        color: "#28A5F4",
      },
      "&.active": {
        color: "#28A5F4",
        fontWeight: 700,
      },
    },
  },
}));

export default useStyles;
